// Minimal, dependency-free CSV export. Handles the edge cases that matter:
// commas, quotes, embedded newlines, and Excel's number-recognition quirks
// (leading-zero stock codes get preserved because we always double-quote
// strings). Prepends a UTF-8 BOM so Excel + Numbers open the file with the
// correct charset without an "encoding" dialog.
export function buildCsv(rows, columns) {
  const header = columns.map((c) => escape(c.label));
  const body = rows.map((r) => columns.map((c) => escape(format(c.get(r), c.type))));
  return "\uFEFF" + [header.join(","), ...body.map((line) => line.join(","))].join("\r\n") + "\r\n";
}

function format(v, type) {
  if (v == null) return "";
  if (type === "money" || type === "number") {
    const n = Number(v);
    if (Number.isNaN(n)) return "";
    return type === "money" ? n.toFixed(2) : String(n);
  }
  if (type === "date") {
    try {
      const d = new Date(v);
      if (Number.isNaN(d.getTime())) return String(v);
      return d.toISOString().slice(0, 19).replace("T", " ");
    } catch {
      return String(v);
    }
  }
  return String(v);
}

function escape(s) {
  const str = String(s ?? "");
  if (str.includes(",") || str.includes("\"") || str.includes("\n") || str.includes("\r")) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function downloadCsv(filename, content) {
  const blob = new Blob([content], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function stampedFilename(prefix, ext) {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  const stamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}-${pad(now.getHours())}${pad(now.getMinutes())}`;
  return `${prefix}-${stamp}.${ext}`;
}
